module.exports = __webpack_public_path__ + "img/main_background.189efcbf.png";